import { combineReducers } from "redux";

import { analyticsConstants } from "../../actions/analytics/index";

const defaultState = {
  status: {
    started: false,
    error: false,
    ended: false,
    errorInfo: {
      code: "",
      message: ""
    }
  }
};

function kpiTitles(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case analyticsConstants.GET_KPI_TITLE_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      },
      user: null
    };
  case analyticsConstants.GET_KPI_TITLE_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload
    };
  case analyticsConstants.GET_KPI_TITLE_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function kpiList(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case analyticsConstants.GET_KPI_LIST_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      },
      user: null
    };
  case analyticsConstants.GET_KPI_LIST_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload
    };
  case analyticsConstants.GET_KPI_LIST_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function getCredits(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case analyticsConstants.GET_CREDITS_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      },
      user: null
    };
  case analyticsConstants.GET_CREDITS_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload
    };
  case analyticsConstants.GET_CREDITS_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}
function getRevenues(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case analyticsConstants.GET_REVENUES_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      },
      user: null
    };
  case analyticsConstants.GET_REVENUES_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload
    };
  case analyticsConstants.GET_REVENUES_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}
function getObligations(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case analyticsConstants.GET_OBLIGATIONS_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      },
      user: null
    };
  case analyticsConstants.GET_OBLIGATIONS_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload
    };
  case analyticsConstants.GET_OBLIGATIONS_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function isBusinessPerformanceActive(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case analyticsConstants.GET_BP_ACTIVE_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      },
      isActive: null
    };
  case analyticsConstants.GET_BP_ACTIVE_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      isActive: payload
    };
  case analyticsConstants.GET_BP_ACTIVE_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      },
      isActive: false
    };
  default:
    return defaultS;
  }
}

export const analytics = combineReducers({
  kpiList,
  kpiTitles,
  getCredits,
  getRevenues,
  getObligations,
  isBusinessPerformanceActive
});

export default analytics;
